import { frontendURL } from '../../../helper/URLHelper';
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/orders'),
      name: 'orders_dashboard',
      component: () => import('./OrdersPage.vue'),
      meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    },
  ],
};
